import ProductStockOrdersHtml from './templates/product-stock-orders.html';

export function ProductStockOrdersDirective () {
  return {
    controller: 'ProductStockOrdersCtrl',
    restrict: 'E',
    templateUrl: ProductStockOrdersHtml,
    scope: {
      orders: '=',
      product: '='
    }
  }
};